"use client";

import { useState, useEffect } from "react";
import Image from "next/image";

const MetallicPaintLogo = ({ size, className }: { size: string; className?: string }) => {
  const [isClient, setIsClient] = useState(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const combinedClass = "paint-container m-0 p-0 " + (className || "") + " flex items-center justify-center";

  return (
    <div
      style={{
        width: "100%",
        height: size,
        position: "relative",
      }}
      className={combinedClass}
    >
      {(!isClient || !isVideoLoaded) && (
        <div className="absolute inset-0 flex items-center justify-center transition-opacity duration-500 z-10">
          <Image
            src="/midas.svg"
            alt="Midas Logo"
            fill
            className="object-contain opacity-50"
            priority
          />
        </div>
      )}

      {isClient && (
        <video
          autoPlay
          loop
          muted
          playsInline
          onLoadedData={() => setIsVideoLoaded(true)}
          className="w-full h-full object-contain relative z-20"
          style={{
            opacity: isVideoLoaded ? 0.9 : 0,
            transition: 'opacity 1s ease',
          }}
        >
          <source src="/logo-animation-looped.webm" type="video/webm" />
          Your browser does not support the video tag.
        </video>
      )}
    </div>
  );
};

export default MetallicPaintLogo;
